import React from 'react';
import { useSelector } from 'react-redux';
import { Auth } from 'aws-amplify';
import { Dropdown } from 'semantic-ui-react';
import { arrowDownSvg } from '../../HelperMethods/constants';
import SvgComponent from '../../common/assets/user_icon';

const isAiBuild = process.env.REACT_APP_ENVIRONMENT.includes('ai');

function LogoutComponent() {
  const { loggedInUser } = useSelector((state) => state.appReducer);
  const firstName = loggedInUser.firstName || '';
  const lastName = loggedInUser.lastName || '';
  //   const date = moment(Date.now()).format('MMM Do YY');
  React.useEffect(() => {});
  async function logout() {
    if (isAiBuild) {
      window.location.href = '/logout';
    } else {
      await Auth.signOut();
    }
  }

  const openDocumentationPageInANewTab = (path) => {
    window.open(`https://w-user-documentation.scrollhelp.site/production/${path}`, '_blank');
  };

  const menuItemsToDisplay = [
    {
      onClick: () => openDocumentationPageInANewTab('joyn-fsm-faq'),
      text: 'FAQ',
    },
    {
      onClick: () => openDocumentationPageInANewTab('joyn-fsm-api-faq'),
      text: 'API FAQ',
    },
    {
      onClick: () => {
        window.open('https://w-user-documentation.scrollhelp.site/v10rn/joyn-fsm-release-notes', '_blank');
      },
      text: 'Release Notes',
    },
    {
      onClick: () => openDocumentationPageInANewTab('joyn-fsm-use-cases'),
      text: 'Case Studies',
    },
    {
      onClick: () => {
        window.open('https://roadmap.prodpad.com/00fe122a-da3c-11ed-8730-0aabe7cf8f61', '_blank');
      },
      text: 'Roadmap',
    },
    {
      onClick: () => logout(),
      text: 'Logout',
    },
  ];

  return (
    <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center' }}>
      <SvgComponent style={{ width: '30px', height: '30px', borderRadius: '50px' }} />
      <div style={{ paddingLeft: '10px' }}>
        <div style={{ fontSize: '11px' }}>
          {firstName}
          {lastName}
        </div>
      </div>
      <Dropdown
        item
        text=""
        icon={
          <img
            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(arrowDownSvg('#a2a2a0'))}`}
            style={{ marginLeft: '5px', paddingLeft: '7px' }}
          />
        }
      >
        <Dropdown.Menu style={{ marginLeft: '-60px' }}>
          <>
            {menuItemsToDisplay.map((menuItem, index) => (
              <Dropdown.Item onClick={menuItem.onClick} key={index}>
                {menuItem.text}
              </Dropdown.Item>
            ))}
          </>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default LogoutComponent;
